import * as React from "react";
import { cn } from "@/lib/utils";

// Dashboard KPI tile that doubles as a table filter. `active` gives it the
// lifted, zee-bordered state; the footer hint switches to the "klik om te wissen" text.
export function StatCard({
  title,
  value,
  caption,
  hint,
  activeHint = "filter actief — klik om te wissen",
  active = false,
  onClick,
  className,
}: {
  title: string;
  value: React.ReactNode;
  caption?: string;
  hint?: string;
  activeHint?: string;
  active?: boolean;
  onClick?: () => void;
  className?: string;
}) {
  const Comp = onClick ? "button" : "div";
  return (
    <Comp
      type={onClick ? "button" : undefined}
      onClick={onClick}
      aria-pressed={onClick ? active : undefined}
      className={cn(
        "flex flex-col gap-1 rounded-card border px-6 pb-5 pt-6 text-left text-waves-ink transition-[transform,box-shadow] duration-150",
        active ? "-translate-y-1 scale-[1.01] border-waves-zee bg-waves-mist shadow-lift" : "border-waves-line bg-white",
        onClick && "cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        onClick && !active && "hover:-translate-y-1 hover:shadow-lift",
        className
      )}
    >
      <div className="min-h-[42px] text-base font-bold leading-[1.3] tracking-[-0.01em]">{title}</div>
      <div className="pb-1 pt-3 text-5xl font-black leading-none tracking-[-0.03em]">{value}</div>
      {caption && <div className="text-sm text-waves-muted">{caption}</div>}
      {hint && (
        <div className="mt-auto self-stretch pt-3">
          <div
            className={cn(
              "border-t border-waves-line pt-2.5 text-[11px] font-bold uppercase tracking-label",
              active ? "text-waves-zee" : "text-waves-muted"
            )}
          >
            {active ? activeHint : hint}
          </div>
        </div>
      )}
    </Comp>
  );
}
